import { useMemo } from 'react';
import { ResetPasswordDetails, Section } from 'views/Auth';

const verificationMethod = {
    phone_number: 'sms',
    email: 'email',
};

export default function useAuthHeader(
    section: Section,
    resetPasswordDetails?: ResetPasswordDetails,
) {
    return useMemo(() => {
        switch (section) {
            case Section.CHANGE_PASSWORD:
                if (resetPasswordDetails)
                    return {
                        title: 'Forgot your password?',
                        subtitle: `We have sent a password reset code by ${verificationMethod[resetPasswordDetails.attributeName] ?? resetPasswordDetails.attributeName} to ${resetPasswordDetails.destination}. Enter it below to reset your password.`,
                    };
                else
                    return {
                        title: 'Forgot your password?',
                        subtitle: '',
                    };
            case Section.RESET_PASSWORD:
                return {
                    title: 'Forgot your password?',
                    subtitle:
                        'Enter your username below and we will send you a message to reset your password.',
                };
            case Section.NEW_PASSWORD_REQUIRED:
                return {
                    title: 'Change Password',
                    subtitle: 'Please enter your new password below.',
                };
            case Section.AUTH:
            default:
                return {
                    title: 'DataHub',
                    subtitle: 'Make Data Accessible Across Novo Nordisk',
                };
        }
    }, [section, resetPasswordDetails]);
}
